import { useTranslation } from "react-i18next";
import LegalPage, { type LegalSection } from "./LegalPage";

export default function TermsOfUse() {
  const { t } = useTranslation();
  const sections = t("legal.terms.sections", { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      title={t("common.legal.termsOfUse")}
      updated={t("legal.terms.updated")}
      sections={sections}
    />
  );
}
